import { makeStyles } from '@material-ui/styles';
import ChevronIcon from 'assets/img/ChevronIcon';
import { whiteColor } from 'assets/jss/material-dashboard-pro-react';
import { IconButton } from '@material-ui/core';
import classNames from 'classnames';
import { DOWNLOAD_REPORT_BUTTON_ID } from 'views/Reports/IndividualMultiplierReport/constants/reportButtonId';

const helpScoutColor = '#2B3D51';

const useStyles = makeStyles({
  scrollButton: {
    width: '60px',
    height: '60px',
    borderRadius: '25px',
    background: helpScoutColor,
    color: whiteColor,
    position: 'fixed',
    bottom: '108px',
    right: '40px',
    zIndex: '1049',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      background: helpScoutColor,
    },
    '@media (max-height: 740px)': {
      bottom: '80px',
      right: '20px',
    },
  },
  chevronIcon: {
    width: '20px',
    height: '20px',
    color: whiteColor,
  },
  chevronIconUp: {
    transform: 'rotate(180deg)',
  },
});

const ScrollButton = ({ isScrollable = false, isAtBottom = false }) => {
  const classes = useStyles();

  const scrollTargetElement = document.getElementById(
    DOWNLOAD_REPORT_BUTTON_ID
  );

  const handleScrollToggle = () => {
    const body = document.querySelector('body');

    const isBodyScroll = window.innerWidth <= 992;

    if (isAtBottom) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
      isBodyScroll
        ? body.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        : window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
    } else {
      scrollTargetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  };

  if (!isScrollable) {
    return null;
  }

  return (
    <IconButton onClick={handleScrollToggle} className={classes.scrollButton}>
      <ChevronIcon
        className={classNames(classes.chevronIcon, {
          [classes.chevronIconUp]: isAtBottom,
        })}
      />
    </IconButton>
  );
};

export default ScrollButton;
